import React, { useState, useEffect }from 'react';
import { TailSpin } from  'react-loader-spinner'
import axios from 'axios';
import SftGlobalData from '../../library/SftGlobalData';
import Colors from '../../library/Colors';
import LicenceCheckBox from './LicenceCheckBox';
import 'react-toastify/dist/ReactToastify.css';
import { Box, styled } from '@mui/material';
import ModalUnstyled from '@mui/base/ModalUnstyled';
import PeppolModal from './peppol/PeppolModal';

const StyledModal = styled(ModalUnstyled)`
    position: fixed;
    text-align: center;
    z-index: 1300;
    right: 0;
    bottom: 0;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    `;

const Backdrop = styled('div')`
    z-index: -1;
    position: fixed;
    right: 0;
    bottom: 0;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    -webkit-tap-highlight-color: transparent;
    `;

const style = {
    border: '0px solid #000',
    borderRadius: 6,
    p: 2,
    px: 4,
    pb: 3,
};

const LicenceAddonForm = (props) =>  {
    const [loading, setLoading] = useState(true);
    const [modules, setModules] = useState([]);
    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState("");
    const [modalTarget, setModalTarget] = useState({});


    useEffect (()=>{
        reloadData();
    }, [props.api]);

    const reloadData = () => {
        try{
            SftGlobalData.post('client&action=fetchAddons', { key: props.api, user: props.username, sftUserId: props.userId}).then(response => {
                setModules(response.data);
                setLoading(false);
            });
        } catch(e){
            console.error(e);
        }
    }

    const handleOpenModal = (value) => {
        setModal(value);
    };

    const onCloseModal = (data) => {
        if(SftGlobalData.debug)
            console.log("postData", data);
        
        setModal(false);
        setLoading(true);
        reloadData();
      
    }

    return (
        <div className={props.theme + " _50perc"}>
            {loading && <div style={{display:"flex", justifyContent: "space-evenly", marginTop: 5}}>
                <TailSpin 
                    height="40"
                    width="40"
                    color={Colors.sft_blue}
                    ariaLabel='loading'
                />
            </div>}
            {!loading && <div style={{display: 'flex', justifyContent: 'flex-start', flexDirection: 'column', alignItems: 'flex-start'}}>
                <StyledModal
                    aria-labelledby="unstyled-modal-title"
                    aria-describedby="unstyled-modal-description"
                    open={modal}
                    onClose={()=>{setModal(false);}}
                    BackdropComponent={Backdrop}
                    >
                    <Box 
                        sx={style} 
                        style={{minWidth: 750, height: (modalContent === "test" ? "75%" : "95%"), width: (modalContent === "test" ? "80%" : "90%")}} 
                        className={props.theme + "  box_fade-in"}>
                            <PeppolModal 
                                api={props.api} 
                                t={props.t} 
                                mod={modules?.find((mod) => mod.mod_id == 61)} 
                                username={props.username}
                                userId={props.userId}
                                theme={props.theme} 
                                onClose={(data)=>{onCloseModal(data);}} 
                                notify={(text, time, position, theme, id) => {props.notify(text, time, position, theme, id);}}
                            />
                    </Box>
                </StyledModal>
                {
                    modules.map((mod) => {
                        return <LicenceCheckBox 
                            disabled={props.disabled} 
                            key={mod.mod_id} theme={props.theme} 
                            checked={mod.active === "Y"} 
                            api={props.api} 
                            database={props.database} 
                            mod={mod} 
                            username={props.username}
                            userId={props.userId}
                            label={<span>&nbsp;&nbsp; <b>{mod.mod_id}</b>&nbsp; - &nbsp; {mod.mod_name} </span>} 
                            onOpenModal={handleOpenModal}
                        />
                    })
                }
            </div>}
        </div>
    );
}

export default LicenceAddonForm;
